module.exports = __webpack_public_path__ + "media/images/lb/247-84e65a11ba2db9c2d6f314d69e2fcc3c.svg";